module.exports = __webpack_public_path__ + "static/img/fs_js.f259e82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fs_js.png
// module id = R9yU
// module chunks = 0